import React, { useState } from "react"
import { MdClose } from "react-icons/md"
import { Modal } from "src/app/admin/_components/modal"
import { List } from "src/components/List/List"
import { snakeCase } from "src/lib/aikagi"
import { useEditingId } from "../../hooks/useEditingId"
import * as styles from "./ModalEditableForm.css"

type Props<T> = {
  opeHref: string
  resource: T
  resourceName: string
  items: [string, string | number | JSX.Element][]
  onSubmit: React.FormEventHandler<HTMLFormElement>
  children?: React.ReactNode
  onDelete?: (id: number) => Promise<void>
  temporary_EDIT_IN_SMOOTHER_OPE_URL?: string
}

export const ModalEditableForm = <T extends { id: number }>({ ...props }: Props<T>) => {
  const allAttributes = Object.entries(snakeCase(props.resource || {}))
  const resourcesId = props.resource?.id

  const { editingId, setEditingId } = useEditingId(props.resourceName)
  const [showDetailModal, setShowDetailModal] = useState(false)

  const showCreateForm = editingId === 0

  return (
    <div className={styles.root}>
      {resourcesId ? (
        <>
          <h2
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: 400,
            }}
          >
            <button onClick={() => setShowDetailModal(true)}>#{resourcesId}</button>
            {/* <a href={props.opeHref} target="_blank">
              #{resourcesId}
            </a> */}
            {props.children && (
              <>
                <button
                  onClick={() => setEditingId((c) => (c === resourcesId ? null : resourcesId))}
                  className={styles.editButton}
                >
                  編集
                </button>
                {props.onDelete && (
                  <button
                    onClick={() => props.onDelete(resourcesId)}
                    className={styles.deleteButton}
                  >
                    削除
                  </button>
                )}
              </>
            )}
            {props.temporary_EDIT_IN_SMOOTHER_OPE_URL && (
              <a
                href={props.temporary_EDIT_IN_SMOOTHER_OPE_URL}
                className={styles.editButton}
                target="_blank"
              >
                編集
              </a>
            )}
          </h2>
          {props.items && <List items={props.items} />}
        </>
      ) : null}
      {editingId === resourcesId || showCreateForm ? (
        <div className={styles.form}>
          <h2 className={styles.formTitle}>
            {editingId ? "編集#" + resourcesId : "新規作成"}
            <button
              onClick={() => setEditingId(null)}
              style={{
                width: 60,
                height: 60,
              }}
            >
              <MdClose />
            </button>
          </h2>
          <form onSubmit={props.onSubmit}>{props.children}</form>
        </div>
      ) : null}
      {showDetailModal && (
        <Modal
          onClose={() => {
            setShowDetailModal(false)
          }}
        >
          <div
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              background: "white",
              padding: 24,
              borderRadius: 8,
              minWidth: 320,
              maxWidth: 800,
              overflowY: "auto",
              maxHeight: "80vh",
            }}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <span style={{ fontWeight: "bold", fontSize: 18 }}>
                レコード内訳: Smoother OPEで開く
              </span>
              <button
                onClick={() => setShowDetailModal(false)}
                style={{ fontSize: 24, background: "none", border: "none", cursor: "pointer" }}
              >
                ×
              </button>
            </div>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                {allAttributes.map(([key, value]) => {
                  return (
                    <tr key={key} style={{ border: "1px solid black" }}>
                      <td
                        style={{
                          fontWeight: "bold",
                          padding: "5px 10px",
                          textAlign: "left",
                          width: "30%",
                        }}
                      >
                        {key}
                      </td>
                      <td
                        style={{
                          padding: "5px 10px",
                          textAlign: "left",
                          width: "70%",
                        }}
                      >
                        {JSON.stringify(value)}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <div style={{ textAlign: "right", marginTop: 16 }}>
              <button
                onClick={() => window.open(props.opeHref, "_blank")}
                style={{
                  color: "#2196f3",
                  border: "1px solid #2196f3",
                  background: "white",
                  padding: "6px 16px",
                  borderRadius: 4,
                  cursor: "pointer",
                  marginRight: 8,
                }}
              >
                Smoother OPEで開く
              </button>
              <button
                onClick={() => setShowDetailModal(false)}
                style={{
                  color: "#888",
                  border: "1px solid #888",
                  background: "white",
                  padding: "6px 16px",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
              >
                閉じる
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}
